<div class="to-release">
  <span>تا انتشار: </span>
</div>
<div class="time-box">
  <span>{{ days() }}</span>
  <span class="time-box-title">روز</span>
</div>
<div class="time-box">
  <span>{{ hours() }}</span>
  <span class="time-box-title">ساعت</span>
</div>
<div class="time-box">
  <span>{{ minutes() }}</span>
  <span class="time-box-title">دقیقه</span>
</div>
